export const UPDATE_START = 'UPDATE_START'
export const UPDATE_END = 'UPDATE_END'

export const CLEAR_START_END_DATES = 'CLEAR_START_END_DATES'

export const START = 'START'
export const END = 'END'

export const DATE_FORMAT = 'MMM DD YYYY'
export const TIME_FORMAT = 'hh:mm a'
